import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { cgpAuthentication } from "../../../modules/cgp-authentication";
import { PanelBarTemplate } from "../../shared/expandable-panelbar/expandable-panelbar.component";
import { cgpCookieHelper } from "../../../modules/cgp-cookie-helper";
import {
    HubConnection,
    HubConnectionBuilder,
    HttpTransportType,
    LogLevel
} from '../../../../node_modules/@aspnet/signalr';
import { getEnv } from "src/modules/utility";
import { config } from "src/config/config";

const signalRUrl = {

    'LOCAL': 'http://localhost:2076/Hub/RequestHub',
    'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/ctwr-service/Hub/RequestHub',
    'QA': 'https://mesc-service-dev.musea2.azure.ext.gm.com/ctwr-service/Hub/RequestHub',
    'TEST': 'https://mesc-service-dev.musea2.azure.ext.gm.com/ctwr-service/Hub/RequestHub',
    //'PROD': 'https://mfg-gateway.cpi.gm.com/ctwr/Hub/RequestHub',
    'PROD': 'https://mfg-gateway.gm.com/ctwr/Hub/RequestHub',

}

const MAX_CONNECTION_TRIES = 5;
const REFRESH_TIMEOUT = 3000;

export const SIGNALR = {
    pAppEvent: 'PartAppTaskUpdate',
    wAppEvent: 'WapTaskUpdate',
    refreshEvent: 'RefreshRequest'
}

/******************************************************************************
 * SIGNALR SERVICE
 * Use signalR events to refresh elements in the UI
 *****************************************************************************/
@Injectable()
export class SignalrService {
    private readonly wfTasks: any = {};
    private readonly loggedInUser: any;
    private refreshInterval: any;
    connection: HubConnection;
    connectionTries = 0;

    constructor() {
        this.loggedInUser = cgpAuthentication.getUserInfo();
    }

    /**
     * Add Workflow Panelbar Task
     * Store wfTask in wfTasks map
     */
    addTask = (task: WfTask) => {
        if (!task.id) task.id = task.form.value.WFTaskId;
        this.wfTasks[task.id] = task;
    }


    /**
     * Initialize signalR Hub Connection
     */
    initialize(): Promise<any> {
        if (this.connection) return Promise.resolve();
        this.createConnection();
        this.registerEvents();
        return this.startConnection();
    }


    /**
     *
     */
    private createConnection() {
        this.connection = new HubConnectionBuilder()
            .withUrl(signalRUrl[getEnv()], {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
                accessTokenFactory: () => this.getToken()
            })
            .configureLogging(LogLevel.Information)
            .build();
    }


    /**
     * Return current Authentication Token
     */
    private getToken(): string {
        return cgpCookieHelper
            .retrieveCookie(config.authentication.authenticationCookie)
            .replace('Bearer_', 'Bearer ');
    }


    /**
     * Start SignalR Connection
     * If the connection fails, retry after 5 seconds (recursive)
     */
    private startConnection(): any {
        this.connectionTries = this.connectionTries + 1;
        if (this.connectionTries > MAX_CONNECTION_TRIES) {
            if (this.refreshInterval) clearInterval(this.refreshInterval);
            return;
        }
        return this.connection
            .stop()
            .then(() => {
                this.connection
                    .start()
                    .then(x => {
                        if (this.refreshInterval) clearInterval(this.refreshInterval);
                    })
                    .catch((e) => {
                        if (!this.refreshInterval) {
                            this.refreshInterval = setInterval(() => this.startConnection(), REFRESH_TIMEOUT);
                        }
                    });
            })
    }


    /**
     *
     */
    private registerEvents() {
        this.connection.on(SIGNALR.pAppEvent, x => this.refresh(x));
        this.connection.on(SIGNALR.wAppEvent, x => this.refresh(x));
    }


    /**
     * Refresh
     * Locate workflow panelbar task
     * Stop the loading spinner
     * Refresh the panelbar for the logged in user
     * @param dataItem
     */
    private refresh(dataItem: any) {
        const key: string = dataItem.wfTaskId;
        const task: WfTask = this.wfTasks[key];
        const gmin = this.loggedInUser.gmin || this.loggedInUser.gmuniqueidentifier;
        if (task) task.panelbar.loading.next(false);
        if (gmin === dataItem.gmin) {
            if (task && task.panelbar) task.panelbar.refresh();
        }
    }

}


/******************************************************************************
 * WORKFLOW PANELBAR TASK
 *****************************************************************************/
export class WfTask {
    id: string;
    form: FormGroup;
    panelbar: PanelBarTemplate
}
